// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"cbad2b7f","694":"2760fb7b"}[chunkId] + ".chunk.js";
};